var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emoji-warp"},[_c('div',{staticClass:"emojis"},_vm._l((_vm.emojis),function(emoji,index){return _c('span',{key:index,staticClass:"emoji",on:{"click":function($event){return _vm.handleClick(emoji)}}},[_vm._v(_vm._s(emoji))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cae1c32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/im/right/chat/Emoji.vue
// module id = null
// module chunks = 